export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;
  const { isMobile } = useDevice();
  const runtimeConfig = useRuntimeConfig();
  const env = runtimeConfig.public.env;
  if (isMobile && env !== 'production') {
    import('eruda').then(eruda => {
      eruda.default.init();
    });
  }
});
